/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import {
  mergeClasses,
  TabList,
  Tab,
  Button,
  Image,
} from '@fluentui/react-components';
import { getFlexItemStyles, getFlexRowStyles } from '../styles/layouts';
import { useMemo, useState } from 'react';
import logoutAsset from '../assets/logout.svg';
import { BrowseTab } from './BrowseTab';
import { PlaylistTab } from './PlaylistTab';

const maxItemsPerPage = 10;

export const TabbedList = ({
  mediaItems,
  browseItems,
  sharingActive,
  nowPlayingId,
  addMediaItem,
  removeMediaItem,
  selectMedia,
  onLogout,
}) => {
  const [selectedValue, setSelectedValue] = useState('tab1');

  const onTabSelect = (event, data) => {
    setSelectedValue(data.value);
  };

  const filteredBrowseItems = useMemo(() => {
    return browseItems.filter(
      (browseItem) =>
        !mediaItems.find((mediaItem) => browseItem.id === mediaItem.id)
    );
  }, [browseItems, mediaItems]);

  const flexRowStyles = getFlexRowStyles();
  const flexItemStyles = getFlexItemStyles();

  const handleBrowseMediaSelect = (item) => {
    addMediaItem(item.id);
    setSelectedValue('tab1');
  };

  return (
    <>
      <div
        style={{ width: '100%' }}
        className={mergeClasses(
          flexRowStyles.root,
          flexRowStyles.vAlignCenter,
          flexItemStyles.noShrink
        )}
      >
        <TabList selectedValue={selectedValue} onTabSelect={onTabSelect}>
          <Tab value="tab1">Playlist</Tab>
          <Tab value="tab2">Browse</Tab>
        </TabList>
        <Button
          appearance="transparent"
          style={{
            width: '20px',
            minWidth: '20px',
            marginTop: 8,
            marginRight: 8,
            marginLeft: 'auto',
          }}
          onClick={onLogout}
        >
          <Image src={logoutAsset} width={20} height={20} />
        </Button>
      </div>
      {selectedValue === 'tab1' && (
        <PlaylistTab
          data={mediaItems}
          maxItemsPerPage={maxItemsPerPage}
          onMediaSelect={selectMedia}
          onMediaRemove={removeMediaItem}
          sharingActive={sharingActive}
          nowPlayingId={nowPlayingId}
        />
      )}

      {selectedValue === 'tab2' && (
        <BrowseTab
          onMediaSelect={handleBrowseMediaSelect}
          data={filteredBrowseItems}
          sharingActive={sharingActive}
          maxItemsPerPage={maxItemsPerPage}
        />
      )}
    </>
  );
};
